import React from 'react'
import {HiArrowNarrowRight} from 'react-icons/hi'
import { Link } from 'react-scroll'

const Home = () => {
  return (
    <div name='home'className='w-full h-screen bg-[#0a192f]'>
        
        {/* container  */}
        <div className="max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full">
            <p className='text-pink-600'>Hi, my name is</p>
            <h1 className='text-4xl sm:text-7xl font-bold text-[#ccd6f6]'>SHAHID SHAIKH</h1>
            <h2 className='text-4xl sm:text-3xl font-bold text-[#8892b0] '>I'm a FRONTEND DEVELOPER, </h2>
            <h2 className='text-4xl sm:text-3xl font-bold text-cyan-300 '>SMART CONTRACT ENGINEER</h2>
            <p className='text-[#8892b0] max-w-[700px] text-lg'>I'm a self taught frontend developer and smart contract engineer.
                Also known as EREN
                I have my interest in the WEB3 world. And 
                HOPE to build something DOPE in WEB3 </p>
            <div>
            <button className='text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-pink-600 hover:border-pink-600'>Know More
            <Link to='/about' smooth={true}  duration={500} />
            <span className='group-hover:rotate-90 duration-300 '>
            <HiArrowNarrowRight className='ml-2' />
            </span>
            </button>
            </div>
        </div>
        
    </div>
  )
}

export default Home